module.exports = __webpack_public_path__ + "img/Glowkit-New.a72ca857.jpg";